import type { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IArticleFormValues } from './ArticleForm';
import { FormCheckableDisclosure } from '~/components/atoms/fields/CheckableDisclosure';
import { FormFileUploader } from '~/components/organisms/fields/FileUploader';

export type IArticleFormGallerySectionProps = IContainerProps & {
  mode: IFormMode;
  form: UseFormReturn<IArticleFormValues>;
  appId: string;
};

export const ArticleFormGallerySection: React.FC<
  IArticleFormGallerySectionProps
> = ({ sx, form, appId }) => {
  const { t } = useTranslation();
  return (
    <FormCheckableDisclosure
      sx={sx}
      label={t('ArticleFormGallerySection.gallery-pictures')}
      control={form.control}
      name="galleryEnabled"
      initiallyExpanded={form.watch('galleryEnabled')}
    >
      <FormFileUploader
        appId={appId}
        control={form.control}
        name="galleryPictures"
        disabled={!form.watch('galleryEnabled')}
        acceptTypes={['picture']}
      />
    </FormCheckableDisclosure>
  );
};
